import { SupportProjects } from "@edp-models/support-projects.model";

export interface ISupportProjectsState {
    supportProjects: SupportProjects;
    supportProjectsGasCompensation: SupportProjects;
}

export const initialSupportProjectsState: ISupportProjectsState = {
    supportProjects: null,
    supportProjectsGasCompensation: null
};
